const isBreakpointMap = (value) => (
  value
  && typeof value === 'object'
  && !Array.isArray(value)
);

export const resolveResponsiveMinHeight = (value, fallback) => (
  value ?? fallback
);

export const buildMobileFrameHeight = (minHeight, fallback) => {
  const resolved = resolveResponsiveMinHeight(minHeight, fallback);

  if (isBreakpointMap(resolved)) {
    const xs = resolved.xs ?? resolved.sm ?? resolved.md ?? 300;
    const sm = resolved.sm ?? resolved.xs ?? xs;

    return {
      xs,
      sm,
      md: '100%',
    };
  }

  return {
    xs: resolved,
    sm: resolved,
    md: '100%',
  };
};

export const buildResponsiveFillHeight = (fill) => (
  fill
    ? { xs: 'auto', md: '100%' }
    : undefined
);

export const buildResponsiveFillMaxHeight = (fill) => (
  fill
    ? { xs: 'none', md: '100%' }
    : undefined
);

export const buildResponsiveFillFlex = (fill) => (
  fill
    ? { xs: '0 0 auto', md: '1 1 0' }
    : undefined
);
